import React, { Component } from "react";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";
import Constants from 'components/utils/constants';
import mapDispatchToProps from 'reducers/actions/dispatchProps';
import LoadingOverlay from 'components/common/loadingOverlay';
import './authstyle.css';
import { AccountHandler } from "chits-data/dist";

let _this=null;
let host = window.location.hostname;
let port = window.location.port;
let _domain=`https://${host}`;
if (host.includes('localhost') || host.includes('192.168')) {
    _domain = `http://${host}:${port}`;
} else if(host.includes('codecubers.lab')) {
    _domain = `http://${host}`;
} 
class Register extends Component {
    constructor(props) { 
        super(props) 
        this._handler = new AccountHandler();
        this.handleFieldChange = this.handleFieldChange.bind(this);
        _this = this;
    };

    state = {
        openOverlay: false,
        form: {
            name: '',
            email: '',
            password: '',
            verifyPassword: '',
            domain: _domain
        }
    };

    handleFieldChange = (e) => {
        let _form = this.state.form;
        _form[e.target.name] = e.target.value;
        this.setState({ form: _form });
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        let _form = this.state.form;
        if (_form.password === '' || (_form.password !== _form.verifyPassword)) {
            this.props.enqueueSnackbar('Password is missing or do not match. Please correct.', {
                variant : 'warning'
            });
            return;
        }
        let instance = this._handler.getInstance();
        instance.defaults.headers['Content-Type'] = 'application/json';
        this.setState({ openOverlay: true })
        await instance
            .post(Constants.URLs.AUTH.REGISTER, this.state.form)
            .then(async (response) => {
                this.setState({ openOverlay: false })
                //console.log(response.data);
                if (response.status !== 201) {
                    this.props.enqueueSnackbar('Error: ' + response.data.msg, {
                        variant : 'error'
                    });
                }
                else {
                    this.props.enqueueSnackbar(`${response.data.msg}`, {
                        variant : 'success'
                    });
                    this.setState({ openOverlay: false })
                    _this.props.history.push("/auth/login");
                }
            })
            .catch((err) => {
                this.setState({ openOverlay: false })
                console.log(err);
                let msg = '';
                if (err.response && err.response.data && err.response.data.message) {
                    msg += err.response.data.message;
                }
                if (err.response && err.response.data && err.response.data.msg) {
                    msg += err.response.data.msg;
                }
                if (msg === '') {
                    msg = "Error: An error occured. Please try again later.";
                }
				this.props.enqueueSnackbar(msg, {
					variant : 'error'
				});
            });
    }
    
    renderRegisterForm() {
        return (
          <form className="form" method="">
            <div className="card card-register text-center theme-splash-background">
              <div className="card-header ">
                <div className="row  justify-content-center">
                  <div className="header-text">
                    <h2 className="card-title font-indie-flower-title">Chits</h2>
                    <h6 className="card-subtitle">
                      Chitfund manager by Gumasta.app
                    </h6>
                    <hr />
                    <h3 className="header text-center">Register</h3>
                  </div>
                </div>
              </div>
              <div className="card-body ">
                <div className="card-body">
                  <div className="form-group">
                    <input
                      name="name"
                      type="name"
                      placeholder="Your Name"
                      className="form-control"
                      value={this.state.form.name}
                      onChange={this.handleFieldChange}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      name="email"
                      type="email"
                      placeholder="Enter email"
                      className="form-control"
                      autoComplete="username"
                      value={this.state.form.email}
                      onChange={this.handleFieldChange}
                    />
                  </div>
                  <div className="form-group new-password-field">
                    {/* <p> */}
                      <input
                        name="password"
                        id="password"
                        type="password"
                        placeholder="Password"
                        className="form-control"
                        autoComplete="new-password"
                        value={this.state.form.password}
                        onChange={this.handleFieldChange}
                      />
                      <i className="bi bi-eye-slash" id="togglePassword" onClick={()=>{
                        const togglePassword = document.querySelector("#togglePassword");
                        const password = document.querySelector("#password");
                        // toggle the type attribute
                        const type = password.getAttribute("type") === "password" ? "text" : "password";
                        password.setAttribute("type", type);
                        // toggle the icon
                        togglePassword.classList.toggle("bi-eye");
                      }}></i>
                    {/* </p> */}
                  </div>
                  <div className="form-group new-password-field">
                    <input
                      name="verifyPassword"
                      id="verifyPassword"
                      type="password"
                      placeholder="Password Confirmation"
                      className="form-control"
                      autoComplete="new-password"
                      value={this.state.form.verifyPassword}
                      onChange={this.handleFieldChange}
                    />
                    <i className="bi bi-eye-slash" id="togglePassword2" onClick={()=>{
                      const togglePassword = document.querySelector("#togglePassword2");
                      const password = document.querySelector("#verifyPassword");
                      // toggle the type attribute
                      const type = password.getAttribute("type") === "password" ? "text" : "password";
                      password.setAttribute("type", type);
                      // toggle the icon
                      togglePassword.classList.toggle("bi-eye");
                    }}></i>
                  </div>
                </div>
              </div>
              <div className="card-footer ml-auto mr-auto">
                <button
                  type="submit"
                  onClick={this.handleSubmit}
                  className="btn btn-warning btn-wd"
                >
                  Create Free Account
                </button>
                <hr />
                <a href="/auth/login">Already a member? Login here</a>
              </div>
            </div>
          </form>
        );
    }

    render() {
        return (
          <div className="container auth-form-container">
            <div className="row">
              <div className="col-md-6 mx-auto auth-panel">
                {this.renderRegisterForm()}
              </div>
            </div>
            {this.state.openOverlay && <LoadingOverlay />}
          </div>
        )
    }
}

Register.propTypes = {};

export default connect(null, mapDispatchToProps)(withSnackbar(Register));